// extracted by mini-css-extract-plugin
export default {"container":"src_container__yFcXH","menu":"src_menu__fOIbV","controls":"src_controls__GTs8X","githubLink":"src_githubLink__zsSrx"};